import React, { useEffect } from "react";
import Login from "./components/Login";
import Browse from "./components/Browse";
import GPTSearch from "./components/GPTSearch";
import { useDispatch } from "react-redux";
import { Route, Routes, useNavigate } from "react-router-dom";
import { addUser, removeUser } from "./store/appSlice";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./utils/firebase";
import { removeMovies } from "./store/movieSlice";

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const { displayName, email, uid } = user;
        dispatch(addUser({ displayName: displayName, email: email, uid: uid }));
        navigate("/browse");
      } else {
        dispatch(removeUser());
        dispatch(removeMovies());
        navigate("/");
      }
    });
    return () => unsubscribe();
  }, []);

  return (
    <Routes>
      <Route path="/" Component={Login} />
      <Route path="/browse" Component={Browse} />
      <Route path="/search" Component={GPTSearch} />
    </Routes>
  );
}

export default App;
